import { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import MedProdRegPanel from '../components/MedProdRegPanel';

const MedProdRegister = () => {
  const [key, setKey] = useState<string>('josef');

  return (
    <Container className="mt-4">
      <h2>Medizinprodukteregister</h2>
      <Tabs activeKey={key} onSelect={(k) => setKey(k || 'josef')} className="mb-3">
        <Tab eventKey="josef" title="Josefstadt">
          <MedProdRegPanel facility="josef" />
        </Tab>
        <Tab eventKey="wilhelm" title="Wilhelmshöhe">
          <MedProdRegPanel facility="wilhelm" />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default MedProdRegister;
